import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { Icon } from '@iconify/react';
// material
import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// components
import { RootState, useSelector } from '@/redux/store';
import { MHidden } from '../../components/@material-extend';
import LoadingScreen from '../../components/LoadingScreen';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import Searchbar from './Searchbar';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    backgroundColor: alpha(theme.palette.background.default, 0.72),
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
    }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: APPBAR_DESKTOP,
        padding: theme.spacing(0, 5)
    }
}));

// ----------------------------------------------------------------------

type DashboardNavbarProps = {
    onOpenSidebar: VoidFunction;
};

export default function DashboardNavbar({ onOpenSidebar }: DashboardNavbarProps): JSX.Element {
    const { isCollapse } = useCollapseDrawer();
    const { isAuthenticating } = useSelector((state: RootState) => state.auth);

    return (
        <>
            {isAuthenticating && (
                <LoadingScreen
                    sx={{
                        ...{
                            top: 0,
                            left: 0,
                            width: 1,
                            zIndex: 9999,
                            position: 'fixed'
                        }
                    }}
                />
            )}
            <RootStyle
                sx={{
                    ...(isCollapse && {
                        width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
                    })
                }}
            >
                <ToolbarStyle>
                    <MHidden width="lgUp">
                        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
                            <Icon icon={menu2Fill} />
                        </IconButton>
                    </MHidden>

                    <Searchbar />
                    <Box sx={{ flexGrow: 1 }} />

                    <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
                        <LanguagePopover />
                        <AccountPopover />
                    </Stack>
                </ToolbarStyle>
            </RootStyle>
        </>
    );
}
